import { elements, state } from './config';

export function openSearch(isBlogSearch: boolean = false): void {
    if (!elements.searchLandingPage) {
        return;
    }

    state.isSearchOpen = true;

    const queryInput = elements.searchLandingPage.querySelector<HTMLInputElement>('input[name=query]');
    const blogSuggestions = elements.searchLandingPage.querySelector<HTMLElement>('#blog-suggestions');
    const pageSuggestions = elements.searchLandingPage.querySelector<HTMLElement>('#page-suggestions');
    const searchTypeInput = elements.searchLandingPage.querySelector<HTMLInputElement>('input[name=search-type]');

    const typeValue: string = isBlogSearch ? 'blog' : 'pages';
    const placeholder: string = queryInput ? (isBlogSearch ? queryInput.dataset.placeholderBlog : queryInput.dataset.placeholderPages) ?? '' : '';
    
    if (blogSuggestions) {
        blogSuggestions.style.display = isBlogSearch ? 'block' : 'none';
    }

    if (pageSuggestions) {
        pageSuggestions.style.display = isBlogSearch ? 'none' : 'block';
    }

    if (searchTypeInput) {
        searchTypeInput.value = typeValue;
    }

    if (queryInput) {
        queryInput.placeholder = placeholder || '';
    }

    elements.body.classList.remove('mp-navbar-mobile-visible');
    elements.searchLandingPage.classList.add('visible');
    elements.searchLandingPage.setAttribute('aria-hidden', 'false');

    setTimeout(() => {
        elements.body.classList.add('search-landing-page--visible');
        const searchInput = document.getElementById('search-landing') as HTMLInputElement | null;

        if (searchInput) {
            searchInput.value = '';
            searchInput.focus();
        }
    }, 0);
}

export function closeSearch(): void {
    if (!elements.searchLandingPage) {
        return;
    }

    state.isSearchOpen = false;
    elements.body.classList.remove('search-landing-page--visible');
    elements.searchLandingPage.classList.remove('visible');
    elements.searchLandingPage.setAttribute('aria-hidden', 'true');
}

export function initSearch(): void {
    if (elements.searchLandingPage) {
        elements.searchLandingPage.setAttribute('aria-hidden', 'true');
    }
}